let proxy = ''

if (window.location.hostname === 'localhost') {
    proxy = 'http://localhost:5000'
} else {
    proxy = window.location.origin
}

export default proxy